'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, ButtonGroup, Heading, Modal, TextPassage } from '@petsmart-ui/sparky';
import { useEffect, useState } from 'react';
import { removePayment } from '@libs/api-proxy-client';
import { BANNERS, logSentryError, SentryAcpCreditCardsErrors as SentryErrors, useAlertBanner, useUserSession } from '@libs/common-next';
import { NotFoundError } from '@libs/core';
import { trackErrorPayment, trackRemovePayment, useManagePayment } from '@libs/shared-ui';
import type { RemoveCardModalProps } from './types';
import './RemoveCardModal.scss';
export function RemoveCardModal(t0) {
  const $ = _c(33);
  const {
    modalOpen,
    modalClose,
    currentPayment
  } = t0;
  const [isLoading, setIsLoading] = useState(false);
  const {
    setAlert
  } = useAlertBanner();
  const {
    userData
  } = useUserSession();
  const {
    syncProfileAfterPaymentChange
  } = useManagePayment();
  let t1;
  if ($[0] !== userData?.payments) {
    t1 = userData?.payments?.some(_temp);
    $[0] = userData?.payments;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hasActiveSubscription = t1;
  const isCardRemoveBlocked = currentPayment.isPrimary && hasActiveSubscription;
  let t2;
  let t3;
  if ($[2] !== isCardRemoveBlocked || $[3] !== modalOpen) {
    t2 = () => {
      if (isCardRemoveBlocked && modalOpen) {
        trackErrorPayment("This card cannot be removed");
      }
    };
    t3 = [isCardRemoveBlocked, modalOpen];
    $[2] = isCardRemoveBlocked;
    $[3] = modalOpen;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== currentPayment.cardId || $[7] !== modalClose || $[8] !== setAlert || $[9] !== syncProfileAfterPaymentChange) {
    t4 = async () => {
      setIsLoading(true);
      ;
      try {
        await removePayment(currentPayment.cardId);
        await syncProfileAfterPaymentChange();
        setAlert({
          ...BANNERS.success
        });
        trackRemovePayment();
      } catch (t5) {
        const error = t5;
        logSentryError(error, SentryErrors.RemoveCardModal.SubmitFailed);
        if (error instanceof NotFoundError) {
          setAlert({
            header: "Unable to remove card",
            text: (error as Error).message ?? "Unable to remove card",
            variant: "error"
          });
          trackErrorPayment((error as Error).message ?? "Unable to remove card");
        } else {
          setAlert({
            header: "Unable to remove card",
            text: "Please try again later",
            variant: "error"
          });
          trackErrorPayment("Unable to remove card");
        }
      }
      setIsLoading(false);
      modalClose(true);
    };
    $[6] = currentPayment.cardId;
    $[7] = modalClose;
    $[8] = setAlert;
    $[9] = syncProfileAfterPaymentChange;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleRemoveCard = t4;
  let t5;
  if ($[11] !== modalClose) {
    t5 = () => modalClose();
    $[11] = modalClose;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Modal.Header><Heading tagName="h6" data-testid="remove-card-modal-heading">Remove card</Heading></Modal.Header>;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== isCardRemoveBlocked) {
    t7 = isCardRemoveBlocked && <Heading size="body-lg-bold" tagName="h6" data-testid="remove-card-modal-subheading">This card cannot be removed</Heading>;
    $[14] = isCardRemoveBlocked;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = isCardRemoveBlocked ? "card-remove-blocked" : "";
  const t9 = isCardRemoveBlocked ? undefined : "lg";
  const t10 = isCardRemoveBlocked ? "Since you have an active subscription, a default card is required on your profile. Set another card as the default payment to remove this card." : "Are you sure you want to remove this card from your account?";
  let t11;
  if ($[16] !== t10 || $[17] !== t8 || $[18] !== t9) {
    t11 = <TextPassage className={t8} size={t9} data-testid="remove-card-modal-text">{t10}</TextPassage>;
    $[16] = t10;
    $[17] = t8;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t7) {
    t12 = <Modal.Body>{t7}{t11}</Modal.Body>;
    $[20] = t11;
    $[21] = t7;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== handleRemoveCard || $[24] !== isCardRemoveBlocked || $[25] !== isLoading || $[26] !== modalClose) {
    t13 = <Modal.Footer><ButtonGroup align="right">{isCardRemoveBlocked ? <Button variant="primary" text="Got it" onClick={() => modalClose()} size="lg" data-testid="got-it-btn" /> : <><Button text="Keep card" onClick={() => modalClose()} size="lg" data-testid="keep-card-btn" /><Button className="danger-btn" variant="primary" text="Remove card" onClick={handleRemoveCard} loading={isLoading} disabled={isLoading} size="lg" data-testid="remove-card-btn" /></>}</ButtonGroup></Modal.Footer>;
    $[23] = handleRemoveCard;
    $[24] = isCardRemoveBlocked;
    $[25] = isLoading;
    $[26] = modalClose;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== modalOpen || $[29] !== t12 || $[30] !== t13 || $[31] !== t5) {
    t14 = <Modal dismissible={true} isActive={modalOpen} onClose={t5} className="remove-card-modal" data-testid="remove-card-modal">{t6}{t12}{t13}</Modal>;
    $[28] = modalOpen;
    $[29] = t12;
    $[30] = t13;
    $[31] = t5;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
}
function _temp(payment) {
  return payment.hasSubscription;
}